import React, { useState } from 'react';
import { Button, Modal, Input, message } from 'antd';
import { insertClasificacion } from '../../services/clasificacioneService';
import { PlusOutlined } from '@ant-design/icons';

const ModalCreateClasificacion = ({ onClasificacionCreated }) => {
  const [loading, setLoading] = useState(false);
  const [openClasificacionModal, setOpenClasificacionModal] = useState(false);
  const [descripcion, setDescripcion] = useState('');

  const handleClasificacionOk = async () => {
    setLoading(true);
    try {
      await insertClasificacion(descripcion); // Inserta la descripción en la clasificación
      message.success('Clasificación creada correctamente.');
      setOpenClasificacionModal(false);
      // Resetear formulario
      setDescripcion('');
      onClasificacionCreated(); // Notificar al componente padre
    } catch (error) {
      message.error('Error al insertar en clasificación.');
    } finally {
      setLoading(false);
    }
  };

  const handleClasificacionCancel = () => {
    setOpenClasificacionModal(false);
  };

  return (
    <>

      <Button
        className='botonDesagregacion'
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => setOpenClasificacionModal(true)}
      />
      <Modal
        open={openClasificacionModal}
        title="Crear Clasificación"
        onOk={handleClasificacionOk}
        onCancel={handleClasificacionCancel}
        footer={[
          <Button key="back" onClick={handleClasificacionCancel}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" loading={loading} onClick={handleClasificacionOk}>
            Crear
          </Button>
        ]}
      >
        <span style={{ display: 'block', textAlign: 'center', marginBottom: 5 }}>Nombre de la Clasificación<span style={{ color: 'red' }}>*</span></span>

        <Input
          placeholder="Nombre de la Clasificación"
          value={descripcion}
          onChange={(e) => setDescripcion(e.target.value)}
          style={{ marginBottom: 10 }}
        />
      </Modal>
    </>
  );
};

export default ModalCreateClasificacion;
